import { render } from "./Index.vue?vue&type=template&id=7f5e401e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=7f5e401e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7f5e401e"

export default script